// src/features/promoteur/BoutonChargily.jsx
import { useAuth } from "@/context/AuthContext";
import { db } from "@/Firebase";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";

const FUNCTION_URL = "https://createchargilycheckout-jrpgc7lgyq-uc.a.run.app";

export default function BoutonChargily({
  serviceName,
  paymentMethod = "",
  customerName,
  customerEmail,
  customerPhone,
  planId = "annual",
  successPath = "/promoteur/paiement-succes",
  failurePath  = "/promoteur/paiement-echec",
}) {
  const { user } = useAuth();
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState(null);
  const [dejaAbonne, setDejaAbonne] = useState(false);
  const [checkDone, setCheckDone]   = useState(false);

  // 🆕 Vérifier crédits disponibles au montage
  useEffect(() => {
    if (!user) return;

    const verifierAbonnement = async () => {
      try {
        const subRef  = doc(db, "chargilySubscriptions", user.uid);
        const subSnap = await getDoc(subRef);

        if (subSnap.exists()) {
          const data = subSnap.data();
          // 🆕 Bloquer seulement si credits > 0 (crédit non encore utilisé)
          if ((data.credits || 0) > 0) {
            setDejaAbonne(true);
          }
        }
      } catch (err) {
        console.error("Erreur vérification abonnement:", err);
      } finally {
        setCheckDone(true);
      }
    };

    verifierAbonnement();
  }, [user]);

  const handlePay = async () => {
    if (!user) {
      setError("Vous devez être connecté pour effectuer un paiement.");
      return;
    }

    if (dejaAbonne) {
      setError("Vous avez déjà un crédit disponible. Publiez votre annonce avant d'effectuer un nouveau paiement.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const idToken = await user.getIdToken(true);

      const response = await fetch(FUNCTION_URL, {
        method: "POST",
        headers: {
          "Content-Type":  "application/json",
          "Authorization": `Bearer ${idToken}`,
        },
        body: JSON.stringify({
          serviceName,
          paymentMethod,
          customerName,
          customerEmail,
          customerPhone,
          planId,
          origin:      window.location.origin,
          successPath,
          failurePath,
        }),
      });

      const data = await response.json();

      if (response.status === 403) {
        setError(data.error);
        return;
      }

      if (!response.ok || !data.checkoutUrl) {
        setError(data.error || "Impossible de créer le paiement. Réessayez.");
        return;
      }

      window.location.href = data.checkoutUrl;

    } catch (err) {
      console.error("Erreur paiement:", err);
      setError(`Erreur: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // 🆕 Crédit disponible non utilisé → bloquer
  if (checkDone && dejaAbonne) {
    return (
      <div style={{
        padding: "14px",
        background: "#fef9c3",
        border: "1px solid #fde047",
        borderRadius: "12px",
        textAlign: "center",
        fontSize: "14px",
        color: "#92400e",
        fontWeight: "600",
      }}>
        ✅ Vous avez déjà un crédit disponible. Publiez votre annonce avant d'effectuer un nouveau paiement.
      </div>
    );
  }

  return (
    <div>
      <button
        onClick={handlePay}
        disabled={loading || !checkDone}
        style={{
          width: "100%",
          padding: "14px",
          background: loading || !checkDone ? "#9ca3af" : "#078D3F",
          color: "#fff",
          border: "none",
          borderRadius: "12px",
          fontSize: "16px",
          fontWeight: "600",
          cursor: loading || !checkDone ? "not-allowed" : "pointer",
          transition: "background 0.2s",
        }}
      >
        {!checkDone
          ? "Vérification..."
          : loading
          ? "Redirection en cours..."
          : "Payer avec Chargily"}
      </button>

      {error && (
        <p style={{ marginTop: 10, fontSize: 13, color: "#dc2626", textAlign: "center" }}>
          {error}
        </p>
      )}
    </div>
  );
}